import React from "react";
import { type Definition } from "~/server/db/lemmas/schema";

import { BadgePos } from "./BadgePOS";

export function DefinitionList({
  definitions = [],
  showTooltip = false,
}: {
  definitions: Definition[];
  showTooltip?: boolean;
}) {
  return (
    <div className="grid grid-cols-[auto_1fr] items-start gap-x-2 gap-y-1 text-sm">
      {definitions.map((definition, index) => (
        <React.Fragment key={index}>
          <BadgePos
            pos={definition.pos}
            showTooltip={showTooltip}
            className="w-fit shrink-0 rounded-sm text-center whitespace-nowrap self-start justify-self-end"
          />
          <div>
            <span>{definition.def}</span>
            {definition.info && (
              <span className="ml-1 text-xs text-muted-foreground">
                ({definition.info})
              </span>
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
